<div *ngIf="company?.Branches?.length>1">
  <div *ngIf="isBranch" class="overlay-branch-selection">
    <div class="branch-selection-holder">
      <div *ngFor="let item of company?.Branches; index as i" class="col-md-3 col-sm-6 col-lg-3">
        <button (click)="selectBranch(item)" class="btn btn-mode">
          <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-6">
              <p class="font-11p"> {{item.BranchDisplayName}}</p>
              <span class="armx-icon armx-building-filled"></span>
            </div>
            <div class="col-md-6 col-sm-4 col-xs-4 align-lft roles-title">
              <h6><b>{{ 'common.roles' | translate }}</b></h6>
              <h6 *ngFor="let role of item.Roles; index as j" class="font-10p">
               <span [innerHtml]="getRoleWithIcon(role.Role.Type)"></span>
              </h6>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
